import { Box } from '@terminal/design-system';

export default function SidebarContainer({
  children,
  type,
}: {
  children: React.ReactNode;
  type: string;
}) {
  return (
    <>
      <Box borderLeft={{ lg: '1px solid #D9D9D9' }} minH={{ lg: '100vh' }}>
        <Box pl={{ base: 4, lg: 8 }} m={{ base: 'auto', lg: '0' }} pt={8}>
          {children}
        </Box>
      </Box>
    </>
  );
}
